import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getShiftAssigendJobDetails, updateEmployerApproval } from "../../slice/workerShiftAddJobSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const EmployerAssigendJobDetails = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id: shiftAssignId } = useParams();
    const token = localStorage.getItem("token");

    const { shiftAssigendJobDetails, loading, error } = useSelector(
        (state) => state.workerShiftJob
    );



    useEffect(() => {
        if (!token) return;

        dispatch(getShiftAssigendJobDetails({ id: shiftAssignId, token }));
    }, [shiftAssignId, token, dispatch]);

    console.log("shiftAssigendJobDetails", shiftAssigendJobDetails);
    const logs = shiftAssigendJobDetails?.shift_request_logs || [];
    const empInfo = shiftAssigendJobDetails?.shift_request_emp;
    const totalHours = shiftAssigendJobDetails?.total_hours;
    const approvedHours = shiftAssigendJobDetails?.approval_total_hours;



    const handleApproval = (logId, status) => {

        const payload = {
            id: logId,
            employer_approval: status
        }

        // Dispatch your Redux action here if you have one
        //   dispatch(updateEmployerApproval({ payload, token }));
        dispatch(updateEmployerApproval({ payload, token }))
            .unwrap()
            .then(() => {
                toast.success("Hours Updated");
                dispatch(getShiftAssigendJobDetails({ id: shiftAssignId, token }));
            })
            .catch(() => {
                toast.error("Failed to updated hours");
            });
    };


    return (
        <>
            <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div className="ps-2 ps-lg-4">
                    <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-3">
                        <h4 className="font-weight-bold text-primary font-size-40 line-hight-2 montserrat mb-0">
                            Working Hours Details
                        </h4>

                        <button
                            className="btn btn-light-header"
                            onClick={() => navigate(-1)}
                        >
                            ← Back
                        </button>
                    </div>


                    <div className="row g-3">
                        <div className="col-12">

                            {/* 🔄 Loading */}
                            {loading && (
                                <div className="d-flex justify-content-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}

                            {/* ❌ Error */}
                            {error && (
                                <div className="alert alert-danger text-center">
                                    {error}
                                </div>
                            )}

                            {/* 📭 No Data */}
                            {!loading &&
                                !error &&
                                (shiftAssigendJobDetails.length === 0) && (
                                    <div className="alert alert-info text-center">
                                        No data found
                                    </div>
                                )}

                            {/* 📊 Table */}
                            {!loading && !error && (
                                <div className="table-responsive">
                                    {empInfo && Object.keys(empInfo).length > 0 ? (
                                        <div className="card mb-4 shadow-sm border-0 rounded-4">
                                            {/* Card Body */}
                                            <div className="card-body p-4">

                                                {/* Job Title Highlight */}
                                                <div className="mb-3">
                                                    <h5 className="fw-bold text-primary mb-1">
                                                        {empInfo.request_title}
                                                    </h5>
                                                </div>

                                                {/* Worker Info */}
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="me-3">
                                                        {/* Avatar or Icon */}
                                                        <div
                                                            className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center"
                                                            style={{ width: "50px", height: "50px", fontSize: "24px" }}
                                                        >
                                                            👤
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h6 className="fw-semibold mb-0">{empInfo.worker_name}</h6>
                                                    </div>
                                                </div>

                                                {/* Additional Details */}
                                                <div className="row text-muted mt-2">
                                                    <div className="col-md-4 mb-2">
                                                        <p className="mb-0"><strong>Email:</strong> {empInfo.worker_email}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <p className="mb-0"><strong>Phone:</strong> {empInfo.worker_phone}</p>
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <p className="mb-0">
                                                            <strong>Shift Dates:</strong> {empInfo.start_date} → {empInfo.end_date}
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    ) : (
                                        <div className="alert alert-warning text-center">
                                            Job is not assigned
                                        </div>
                                    )}



                                    <div className="row g-3 mb-4">
                                        <div className="col-md-6">
                                            <div className="card shadow-sm border-0 h-100">
                                                <div className="card-body text-center">
                                                    <h6 className="text-muted mb-1">⏱️ Total Worked Hours</h6>
                                                    <h4 className="fw-bold text-primary">
                                                        {totalHours || "00:00:00"}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="card shadow-sm border-0 h-100">
                                                <div className="card-body text-center">
                                                    <h6 className="text-muted mb-1">✅ Approved Hours</h6>
                                                    <h4 className="fw-bold text-success">
                                                        {approvedHours || "00:00:00"}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">Check-in Date</th>
                                                <th scope="col">Check-in Time</th>
                                                <th scope="col">Check-out Date</th>
                                                <th scope="col">Check-out Time</th>
                                                <th scope="col">Hours Worked</th>
                                                <th scope="col">Employer Approval</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {logs.length > 0 ? (
                                                logs.map((log) => (
                                                    <tr key={log.id}>
                                                        <td>{log.check_in_date || "-"}</td>
                                                        <td>{log.check_in_time || "-"}</td>
                                                        <td>{log.check_out_date || "-"}</td>
                                                        <td>{log.check_out_time || "-"}</td>
                                                        <td>{log.hours_worked || "-"}</td>
                                                        <td>
                                                            {log.employer_approval ? (
                                                                <span
                                                                    className={`badge ${log.employer_approval === "yes" ? "bg-success" : "bg-danger"
                                                                        }`}
                                                                >
                                                                    {log.employer_approval.toUpperCase()}
                                                                </span>
                                                            ) : (
                                                                <div className="d-flex gap-2">
                                                                    <button
                                                                        className="btn btn-outline-success btn-sm"
                                                                        onClick={() => handleApproval(log.id, "yes")}
                                                                        title="Approve"
                                                                    >
                                                                        ✔️
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-outline-danger btn-sm"
                                                                        onClick={() => handleApproval(log.id, "no")}
                                                                        title="Reject"
                                                                    >
                                                                        ❌
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={6} className="text-center text-muted">
                                                        No logs available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>


                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default EmployerAssigendJobDetails;